import * as CanvasFolderArtifactDAO from 'canvas-core/network/CanvasFolderArtifactDAO';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FolderSelectorModal from 'file-browser/FolderSelectorModal';
import FileStates from 'FileStates';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import notifications from 'notifications';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import {getUserMessage} from 'util/Net';
import {GenericEvent} from 'util/Types';

const SAVE_CANVAS_ERROR_MESSAGE = 'Failed to save canvas.';
const OPEN_SAVED_CANVAS_ERROR_MESSAGE = 'Canvas was saved, but it could not be opened.';
const DUPLICATE_CANVAS_ARTIFACT_MESSAGE = 'An artifact with the same name already exists in this folder.';

export function saveChatCanvasToFolder({
  name,
  canvasVersionId,
}: {
  name: string;
  canvasVersionId: string;
}): void {
  FolderSelectorModal.openForSelect(
    'append',
    {
      showInventory: true,
      showNotebook: true,
      showRegistries: false,
      title: 'Save Canvas Artifact',
      submitText: 'Save',
      initialFolderId: FolderDefaults.get(FolderDefaultsKey.CANVAS_ARTIFACT) ?? null,
    },
    async (e: GenericEvent) => {
      LoadingScreen.show();
      try {
        const {folderId} = RegistryUtil.parseFolderValue(e.target.value);
        if (folderId == null) {
          notifications.error('Select a folder to save this canvas.');
          return;
        }

        let createdIds: Array<string>;
        try {
          ({createdIds} = await CanvasFolderArtifactDAO.createCanvasFolderArtifact({
            name,
            folderId,
            canvasVersion: canvasVersionId,
          }));
          // eslint-disable-next-line benchlint/always-throw-from-catch -- expected API errors are shown as toasts
        } catch (error) {
          const userMessage = getUserMessage(error);
          if (userMessage === DUPLICATE_CANVAS_ARTIFACT_MESSAGE) {
            notifications.warn(userMessage);
          } else {
            notifications.error(userMessage ?? SAVE_CANVAS_ERROR_MESSAGE);
          }
          return;
        }

        if (createdIds.length === 0) {
          notifications.error(SAVE_CANVAS_ERROR_MESSAGE);
          return;
        }
        const createdId = createdIds[0];
        FolderDefaults.set(FolderDefaultsKey.CANVAS_ARTIFACT, folderId);
        FolderDAOCache.invalidateFolderContents(folderId);

        try {
          await FileStates.get().openFolderItem(createdId);
          // eslint-disable-next-line benchlint/always-throw-from-catch -- the artifact is already saved
        } catch (error) {
          const userMessage = getUserMessage(error);
          notifications.error(
            userMessage == null
              ? OPEN_SAVED_CANVAS_ERROR_MESSAGE
              : `${OPEN_SAVED_CANVAS_ERROR_MESSAGE} ${userMessage}`
          );
        }
      } finally {
        LoadingScreen.hide();
      }
    }
  );
}
